/* Section: signup-pop — first-visit / exit-intent email capture.
   Shows once per device via localStorage, or when the user moves the
   mouse sharply toward the top edge (exit-intent heuristic). */
(() => {
  const pop = document.querySelector('[data-section="signup-pop"]');
  if (!pop) return;

  const KEY = 'tph:signup-pop:v1';
  const DELAY_MS = 8000;

  let alreadyShown = false;
  try { alreadyShown = !!localStorage.getItem(KEY); } catch {}
  if (alreadyShown) return;

  const close = (reason = 'closed') => {
    pop.classList.remove('signup-pop--open');
    document.body.style.overflow = '';
    try { localStorage.setItem(KEY, JSON.stringify({ dismissed: true, reason, at: Date.now() })); } catch {}
    detach();
  };
  const open = () => {
    if (alreadyShown) return;
    alreadyShown = true;
    pop.classList.add('signup-pop--open');
    document.body.style.overflow = 'hidden';
    detach();
  };

  const onExit = (e) => {
    if (e.clientY <= 10) open();
  };

  const delayedOpen = setTimeout(open, DELAY_MS);

  function detach() {
    clearTimeout(delayedOpen);
    document.removeEventListener('mouseleave', onExit);
  }

  document.addEventListener('mouseleave', onExit);

  pop.querySelector('.signup-pop__close')?.addEventListener('click', () => close('x'));
  pop.querySelector('.signup-pop__dismiss')?.addEventListener('click', () => close('dismissed'));
  pop.addEventListener('click', (e) => { if (e.target === pop) close('scrim'); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && pop.classList.contains('signup-pop--open')) close('esc');
  });

  pop.querySelector('.signup-pop__form')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = pop.querySelector('input[type="email"]');
    if (!input || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value || '')) {
      input?.focus();
      return;
    }
    const body = pop.querySelector('.signup-pop__body');
    if (!body) return;
    body.innerHTML = `
      <div class="signup-pop__success">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7 12l3 3 7-7"/></svg>
        <h3 class="signup-pop__title" style="font-size: 2rem;">You're in</h3>
        <p class="signup-pop__copy">Here's your 10% off code — good on any hat. Check your inbox for the receipt.</p>
        <p class="signup-pop__code">PARTY10</p>
        <button class="signup-pop__dismiss" type="button" data-close>Keep shopping</button>
      </div>
    `;
    body.querySelector('[data-close]')?.addEventListener('click', () => close('subscribed'));
    try { localStorage.setItem(KEY, JSON.stringify({ subscribed: true, at: Date.now() })); } catch {}
  });
})();
